import Container = PIXI.Container;
import { AbstractWindow } from '../../windows/AbstractWindow';
import { SceneManager } from './SceneManager';
import { MainMenu } from '../../windows/mainMenu/MainMenu';

export enum WindowName {
  MainMenu = 'MainMenu',
}

export class WindowManager {
  private static _instance: WindowManager;
  private stage: Container = SceneManager.getInstance().stage;

  private windows: Map<WindowName, AbstractWindow> = new Map<WindowName, AbstractWindow>();
  private activeWindow: AbstractWindow;

  public getView(windowName: WindowName, params?: any, forceNew: boolean = false): AbstractWindow {
    if (forceNew && this.windows[windowName]) {
      this.destroyWindow(windowName);
    }

    if (this.windows[windowName]) {
      return this.windows[windowName];
    } else {
      let newWindow: AbstractWindow;
      switch (windowName) {
        case WindowName.MainMenu: {
          newWindow = new MainMenu(windowName, params);
          break;
        }
      }
      this.windows[windowName] = newWindow;
      newWindow.onRegister();
      return newWindow;
    }
  }

  public static getInstance(): WindowManager {
    return this._instance || (this._instance = new this());
  }

  public show(name: WindowName): void {
    if (this.activeWindow) {
      this.activeWindow.hide();
    }
    const window: AbstractWindow = this.getView(name);
    this.activeWindow = window;
    window.visible = true;
    this.stage.addChild(window);
  }

  public hide(name: WindowName): void {
    const window: AbstractWindow = this.getView(name);
    if (this.activeWindow === window) {
      window.visible = false;
      this.stage.removeChild(window);
      this.activeWindow = null;
    }
  }

  public destroyWindow(name: WindowName): void {
    this.stage.removeChild(this.windows[name]);
    this.windows[name].destroy({children: true});
    this.windows[name] = null;
  }
}